import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import './design-system.css'
import './visual-audit.css'
import './anotacripto-theme.css'

createRoot(document.getElementById('root')!).render(<StrictMode><App /></StrictMode>)

